import { render, staticRenderFns } from "./RouteAssignmentsListCard.vue?vue&type=template&id=19e3beda&"
import script from "./RouteAssignmentsListCard.vue?vue&type=script&lang=js&"
export * from "./RouteAssignmentsListCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QBanner from 'quasar/src/components/banner/QBanner.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QBanner,QIcon});
